import { useCreditMemos } from '@/data/hubspot/queries/receivables/credit-memo';
import { InvoicesData } from '@/data/hubspot/types/invoices';
import { formatCurrency } from '@/lib/currency-utils';
import { Table } from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import dayjs from 'dayjs';
import { useState } from 'react';

export default function CreditMemoList() {
  // Local States
  const [page, setPage] = useState(1);
  const [isDescending, setIsDescending] = useState(true);

  // Queries
  const { data,isLoading } = useCreditMemos({
    page,
    sort_by: isDescending ? 'DESC' : 'ASC',
    sort_col: 'AMOUNT',
  });

  return (
    <div>
      <Table
      loading={isLoading}
        className="m-4"
        scroll={{ x: 'max-content' }}
        onChange={(_pagination, _filters, sorter) => {
          const newIsDescending = (sorter as SorterResult<InvoicesData>).order === 'descend';
          setIsDescending(newIsDescending);
          const isSorted = newIsDescending !== isDescending;
          if (isSorted) {
            setPage(1);
          }
        }}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: false,
          current: page,
          total: data?.total_records,
          onChange(page) {
            setPage(page);
          },
        }}
        columns={[
          {
            title: 'Reference#',
            key: 'reference',
            render: (_, record) => (
              <div className="flex items-center justify-between">
                <div>
                  <span className="text-[var(--brand-primary)]">{record.reference}</span>
                </div>
              </div>
            ),
          },
          {
            title: 'Credit Notes',
            key: 'creditNote',
            render: (_, record) => <div>{record.note}</div>,
          },

          {
            title: 'Credit Amount',
            key: 'amount',
            sorter: true,
            sortOrder: isDescending ? 'descend' : 'ascend',
            sortDirections: ['descend', 'ascend', 'descend'],
            render: (_, record) => (
              <div className="flex flex-col">
                {formatCurrency(record.amount, {
                  currency: record.currency,
                })}
              </div>
            ),
          },
          {
            title: 'Invoices',
            key: 'invoices',
            render: (_, { invoices }) => (
              <div className="flex flex-col">
                {invoices.map((x) => (
                  <div key={x.id}>{x.invoice_no}</div>
                ))}
                {!!invoices.slice(2).length && <div>+{invoices.slice(2).length}</div>}
              </div>
            ),
          },
          {
            title: 'Created By',
            key: 'createdBy',
            hidden: true,
            render: (_, record) => (
              <div className="flex flex-col">
                <div>{record.created_by.first_name + ' ' + record.created_by.last_name}</div>
                <div>{dayjs(record.credit_memo_date).format('ll')}</div>
              </div>
            ),
          },
        ]}
        dataSource={data?.list}
      />
    </div>
  );
}
